<div class="card-header">
    <h4 [ngClass]="{'card-header-h4-pre-power-tool': inputParams.isRestricted}">{{ inputParams.sectionTitle }}</h4>
    <h4 *ngIf="inputParams.isRestricted" class="power-tool-header"><i class="fal fa-lock-alt"></i> Premium Feature</h4>
</div>
<div class="card-body" [ngClass]="{'no-padding': inputParams.noPadding, 'should-not-be-restricted': !inputParams.isRestricted, 'card-body-overflow': !inputParams.doubleHeight, 'card-body-overflow-double': inputParams.doubleHeight}">
    <div *ngIf="inputParams.isRestricted" class="speak-to-sales-popover">
        <span class="sample-data-shown-text"><i class="fal fa-lock-alt"></i> Sample Data Shown</span>
        <a class="basic-button-base button-light" href="mailto:sales@zint.io?Subject=Zint%20Demo%20Request" target="_blank">Book A Demo</a>
    </div>
    <div [ngClass]="{'blurred-text': inputParams.isRestricted}">
        <ng-content></ng-content>
    </div>
</div>
